/* C14 · qt-chat.js — one schedule (days + hours in the shop time zone) drives the dot, label,
   aria-label and click. Inside hours: WhatsApp (new tab, noopener). Outside: offline note with the
   next opening + FAQ link; WhatsApp never opens. [data-qt-chat-open] elsewhere (FAQ) triggers the button. Spec: 01-componenten.md C14. */
const root = document.querySelector('[data-qt-chat]');
const tpl = (name) => root.querySelector(`[data-${name}]`).innerHTML.trim();

function state() {
  const { days, open, close, tz } = root.dataset;
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: tz, weekday: 'short', hour: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
  const get = (type) => parts.find((p) => p.type === type).value;
  const day = 'MonTueWedThuFriSatSun'.indexOf(get('weekday')) / 3;
  const hour = +get('hour');
  if (days[day] == 1 && hour >= open && hour < close) return { open: 1 };
  for (let i = 0; i < 8; i++) {
    const d = (day + i) % 7;
    if (days[d] != 1 || (!i && hour >= open)) continue;
    return { when: i < 2 ? tpl(i ? 'when-tomorrow' : 'when-today') : tpl('when-weekday').replace('[day]', tpl('weekdays').split(',')[d]) };
  }
  return { when: '' };
}

if (root) {
  const button = root.querySelector('[data-chat-button]');
  const label = root.querySelector('[data-chat-label]');
  const update = () => {
    const s = state();
    root.classList.toggle('is-closed', !s.open);
    root.classList.add('is-ready');
    label.textContent = label.dataset[s.open ? 'openLabel' : 'closedLabel'];
    if (s.open) Object.assign(button, { href: root.dataset.wa, target: '_blank', rel: 'noopener' });
    else {
      button.removeAttribute('target');
      button.setAttribute('role', 'button');
      button.setAttribute('aria-label', tpl('aria-closed').replace('[when]', s.when));
    }
    return s;
  };
  update();
  document.querySelectorAll('[data-qt-chat-open]').forEach((el) => {
    el.hidden = false;
    el.onclick = () => button.click();
  });
  root.addEventListener('click', (event) => {
    if (event.target.closest('[data-chat-note-close]')) root.querySelector('.qt-chat__note')?.remove();
  });
  button.addEventListener('click', (event) => {
    const s = update();
    if (s.open) return;
    event.preventDefault();
    const old = root.querySelector('.qt-chat__note');
    if (old) return old.remove();
    root.insertAdjacentHTML('afterbegin', tpl('note').replace('[when]', s.when.replace(/[<&]/g, '')));
  });
}
